import * as types from "./types";

export const getEventPayrollsRequest = (payload) => ({
  type: types.GET_EVENT_PAYROLLS_REQUEST,
  payload,
});

export const getEventPayrollsResponse = (payload) => ({
  type: types.GET_EVENT_PAYROLLS_RESPONSE,
  payload,
});

export const getEventPayrollStatsRequest = (payload) => ({
  type: types.GET_EVENT_PAYROLL_STATS_REQUEST,
  payload,
});

export const getEventPayrollStatsResponse = (payload) => ({
  type: types.GET_EVENT_PAYROLL_STATS_RESPONSE,
  payload,
});
